<template>
  <a-modal
    :visible="visible"
    wrap-class-name="confirm-modal"
    :title="config.title"
    :width="config.width"
    :ok-text="config.confirmText"
    :cancel-text="config.cancelText"
    :mask-closable="false"
    @ok="submit"
    @cancel="close()"
  >
    <div class="cont">
      <svg
        viewBox="64 64 896 896"
        focusable="false"
        data-icon="exclamation-circle"
        width="40px"
        height="40px"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
        ></path>
        <path
          d="M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
        ></path>
      </svg>
      <p>确认生成Sitemap吗？</p>
    </div>
  </a-modal>
</template>
<script>
import API from "../api";
import moment from "moment";
import Vue from "vue";

export default {
  name: "Customer",
  data() {
    return {
      visible: false,
      config: {
        title: "确认提交",
        width: "460px",
        confirmText: "确定",
        cancelText: "取消",
      },
    };
  },
  props: {},
  created() {},
  mounted() {},
  computed: {},
  components: {},
  methods: {
    open(data) {
      this.visible = true;
    },
    submit() {
      let THAT = this;
      THAT.close()
      THAT.$emit("confirm");
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.confirm-modal .cont {
  text-align: center;
}
.confirm-modal .cont svg {
  color: #faad14;
}
</style>
<style>
.confirm-modal .ant-modal-body {
  padding-bottom: 10px !important;
}
.confirm-modal .ant-modal-footer {
  border-top: none;
  padding: 10px 16px 30px;
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
.confirm-modal .ant-modal-footer>div {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
.confirm-modal .ant-btn+.ant-btn {
  margin-right: 20px;
}
</style>
